/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-imports */
import React, { useMemo, useState } from "react";
import { Formik } from "formik";

import {
  Card,
  CardBody,
  CardHeader,
} from "../../_metronic/_partials/controls";


import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Setting from "./Setting";
import SmtpPage from "./SmtpPage";
import PopupContent from "./PopupContent";
import HomeBanner from "./HomeBanner";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    color: 'red'
  },
}));


function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

export default function MainSetting() {

  const classes = useStyles();
  const [value, setValue] = useState(0);


  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <Card>
      <CardHeader title='Settings'>
      </CardHeader>{" "}  
      <CardBody>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          className={classes.root}
        >
          <Tab label="Maintenance Mode" />
          <Tab label="SMTP Details" />
          <Tab label="POPUP Content" />
          <Tab label="Home Page Banner" />
         
        </Tabs>
        {value === 0 && <TabContainer><Setting/></TabContainer>}
        {value === 1 && <TabContainer><SmtpPage/></TabContainer>}
        {value === 2 && <TabContainer><PopupContent/></TabContainer>}
        {value === 3 && <TabContainer><HomeBanner/></TabContainer>}
      </CardBody>
    </Card>
  );
}
